<template>
  <div class="import-container" style="text-align: center;">
    <h5>班级信息上传</h5>
    <el-upload
      class="upload-excel"
      ref="uploadRef"
      action=""
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept=".xlsx, .xls"
      auto-upload="false"
    >
      <template #trigger>
        <el-button type="primary">选择Excel文件</el-button>
      </template>
    </el-upload>
    <el-button
      style="margin-left: 10px;"
      type="success"
      @click="submitFile"
      :loading="loading"
    >上传到服务器</el-button>

    <el-dialog v-model="dialogVisible" title="文件校验结果" width="60%">
      <div class="file-total">共计 <b>{{ fileTotal }}</b> 个班级（本次上传文件）</div>
      <div class="change-summary">
        新增 <b style="color:green;">{{ changeSummary['新增'] }}</b> 条，
        修改 <b style="color:#409EFF;">{{ changeSummary['覆盖'] }}</b> 条，
        删除 <b style="color:orange;">{{ changeSummary['删除'] }}</b> 条，
        未变化 <b style="color:#909399;">{{ changeSummary['未变化'] }}</b> 条，
        错误 <b style="color:red;">{{ changeSummary['错误'] }}</b> 条
      </div>
      <el-table :data="sortedChanges" style="width: 100%">
        <el-table-column prop="grade" label="年段"></el-table-column>
        <el-table-column prop="class" label="班级号"></el-table-column>
        <el-table-column prop="teacher" label="教师"></el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template #default="{ row }">
            <span :style="{ color: getStatusColor(row.status) }">{{ row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="变更详情" min-width="240">
          <template #default="{ row }">
            <div v-if="row.diffs && row.diffs.length" class="diff-list">
              <div v-for="(d, i) in row.diffs" :key="i">
                {{ d.field }}：<span class="old-val">{{ d.old || '（空）' }}</span>
                <span class="arrow">→</span>
                <span class="new-val">{{ d.new || '（空）' }}</span>
              </div>
            </div>
            <span v-else-if="row.status === '新增'" style="color:green;">全部为新增数据</span>
            <span v-else-if="row.status === '删除'" style="color:orange;">该班级将被删除</span>
            <span v-else-if="row.status === '错误'" style="color:red;">{{ row.error || '数据错误' }}</span>
            <span v-else style="color:#909399;">无变化</span>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button v-if="canConfirm" type="primary" :loading="loading" @click="confirmChanges">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  name: 'ImportPage',
  data() {
    return {
      file: null,
      loading: false,
      dialogVisible: false,
      changes: [],
    };
  },
  computed: {
    sortedChanges() {
      const rank = { '错误': 0, '删除': 1, '覆盖': 2, '新增': 3, '未变化': 4 };
      return this.changes.slice().sort((a, b) => {
        const ra = rank[a.status] ?? 9;
        const rb = rank[b.status] ?? 9;
        return ra - rb;
      });
    },
    changeSummary() {
      const summary = { '新增': 0, '覆盖': 0, '删除': 0, '未变化': 0, '错误': 0 };
      this.changes.forEach((c) => {
        if (summary[c.status] !== undefined) summary[c.status] += 1;
      });
      return summary;
    },
    fileTotal() {
      return this.changes.filter((c) => c.status !== '删除').length;
    },
    canConfirm() {
      return this.changes.every((change) => change.status !== '错误');
    },
  },
  methods: {
    beforeUpload(file) {
      this.file = file;
      return false;
    },
    handleUpload() {},
    submitFile() {
      if (!this.file) {
        ElMessage.error('请先选择一个文件');
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.file);
      axios.post('/api/upload_class', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        this.loading = false;
        this.changes = response.data.changes;
        this.dialogVisible = true;
        this.file = null;
        this.$refs.uploadRef.clearFiles();
      }).catch((error) => {
        this.loading = false;
        ElMessage.error(error.response?.data?.error || '文件上传失败');
      });
    },
    confirmChanges() {
      this.loading = true;
      axios.post('/api/confirm_class_changes', { changes: this.changes })
        .then(() => {
          ElMessage.success('数据已成功更新');
          this.dialogVisible = false;
          this.loading = false;
        })
        .catch((error) => {
          ElMessage.error(error.response?.data?.error || '更新数据时出错');
          this.loading = false;
        });
    },
    getStatusColor(status) {
      switch (status) {
        case '错误': return 'red';
        case '删除': return 'orange';
        case '覆盖': return '#409EFF';
        case '新增': return 'green';
        case '未变化': return '#909399';
        default: return 'black';
      }
    },
  },
};
</script>

<style scoped>
.import-container {
  padding: 20px;
}
.file-total {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #303133;
}
.change-summary {
  margin-bottom: 12px;
  font-size: 14px;
  color: #606266;
}
.diff-list {
  text-align: left;
  line-height: 1.7;
}
.old-val {
  color: #f56c6c;
  text-decoration: line-through;
}
.new-val {
  color: #67c23a;
  font-weight: 600;
}
.arrow {
  margin: 0 4px;
  color: #909399;
}
.upload-excel {
  margin-bottom: 10px;
}
</style>